module.exports = __webpack_public_path__ + "img/form-title.4bd6235b.svg";